import React from 'react';
import MatchTable from '../Common/MatchTable';
import { Remark } from '../Common/MatchBase';

const TEAMCHL = () => {
    return (
        <section className='TEAMCHL'>
            <MatchTable betType='TEAMCHL' etBetType="TEAMECH" />
            <Remark />
        </section>
    )
}
export default TEAMCHL;